import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC, ReactNode } from 'react'

interface HeadingProps {
    children: ReactNode
}

const Heading: FC<HeadingProps> = ({ children }) => {
    return (
        <Typography.Heading variant="h3" numberOfLines={1} style={{ color: ColorEnum.Jet700 }}>
            {children}
        </Typography.Heading>
    )
}

export default Heading
